const sdLoggerModule = angular.module("sdLogger", ["sdApp.config"]);

export default sdLoggerModule;
